import { useUrlUpload } from "client/hooks/upload/useUrlUpload";
import { HandleFile } from "client/types/HandleFile";
import { UploadOptions } from "client/types/UploadOptions";
import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { CloseIcon } from "../Icons/CloseIcon";
import { Modal } from "../Modal/Modal";
import { Translate } from "../Translate/Translate";
import { UrlInput } from "../UrlInput/UrlInput";
import { getRandomId } from "client/utils/getRandomId";

export interface UrlUploadModalProps {
    isOpen: boolean;
    close?: () => void;
    handleFile: HandleFile;
    options: Omit<UploadOptions, "allowMultiple">;
}

export const UrlUploadModal = ({ isOpen, handleFile, close, options }: UrlUploadModalProps) => {
    const { url, error, handleChange, handleKeyPress, handleSubmit, isValidating, handleReset } = useUrlUpload(
        handleFile,
        close ?? (() => {}),
        options,
    );

    return (
        <Modal isOpen={isOpen} close={close}>
            <div className="text-white flex items-center justify-center h-screen max-w-1440 w-full" onClick={close}>
                <div
                    className="w-full mx-2 p-2"
                    style={{
                        maxWidth: "840px",
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    <div className="w-full flex justify-center bg-irBlue-200 dark:bg-darkSurface-300 py-20 rounded-lg border-4 border-dashed border-irBlue-600 dark:border-darkSurface-100 relative">
                        <div className="flex flex-col gap-6 px-4">
                            <div className="capitalize font-semibold">
                                <Translate keyName="common:enter-url-here" />
                            </div>
                            <UrlInput
                                url={url}
                                handleChange={handleChange}
                                handleKeyPress={handleKeyPress}
                                handleSubmit={handleSubmit}
                                isValidating={isValidating}
                            />
                            {url && error && (
                                <div className="font-semibold text-red-700">
                                    {capitalize(translateFunc("error"))}: {error}
                                </div>
                            )}
                        </div>

                        <div
                            className="cursor-pointer absolute right-4 top-4 hover:bg-irBlue-600 dark:hover:bg-darkSurface-200 p-2 rounded-full bg-opacity-25 bg-[#F2F2F240]"
                            onClick={() => {
                                handleReset();
                                close && close();
                            }}
                        >
                            <CloseIcon className="stroke-white" width={8} height={8} />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
